import { createContext } from 'react'

import { BillingInfo, CommerceSystems } from 'types/Billing'
import { CopilotLegalTerms, CopilotLegalTermsStatus } from 'types/CopilotLegalTerms'
import { DynamicSetupConfig } from 'types/DynamicSetupConfig'
import { GuidedSetupConfig } from 'types/GuidedSetupConfig'
import { ProductMigrationDetails } from 'types/MigrationsDetails'
import { PBX } from 'types/Pbx'
import { PbxSmsCampaignDetails } from 'types/PbxSmsCampaignDetails'
import { ProductsSettings } from 'types/ProductSettings'
import { ProductsExploration } from 'types/ProductsExploration'
import { Subscription } from 'types/Subscription'
import { LicensesDetails } from '../../utils'

export interface OrganizationContext extends PBX {
  guidedSetupConfig?: GuidedSetupConfig
  dynamicSetupConfig?: DynamicSetupConfig
  pbxSmsCampaignDetails?: PbxSmsCampaignDetails
  productsExploration?: ProductsExploration
  copilotLegalTerms?: CopilotLegalTerms
  onCopilotLegalTermsAgreements?: (legalTermsStatus: CopilotLegalTermsStatus) => void
  showJive?: boolean
  showVirtualFax?: boolean
  useRebranding2021?: boolean
  showRooms?: boolean
  showAssist?: boolean
  showWebinar?: boolean
  showTraining?: boolean
  showMeetings?: boolean
  showResolve?: boolean
  showHelpdesk?: boolean
  showCustomerEngagement?: boolean
  showResolveHelpline?: boolean
  showResolveKnowledgebase?: boolean
  showSwitchBackDialog?: boolean
  showSettingsTemplate?: boolean
  showPbxDeactivatedBanner?: boolean
  setShowSwitchBackDialog: React.Dispatch<React.SetStateAction<boolean>>
  showUpgradeDialog?: boolean
  setShowUpgradeDialog: React.Dispatch<React.SetStateAction<boolean>>
  handleUpgrade: (pbxId: string) => Promise<any>
  licensesDetails?: LicensesDetails
  billingUserKey?: string
  hasPaidLicense?: boolean
  billingInfo?: BillingInfo
  subscriptions?: Subscription[]
  commerceSystems?: CommerceSystems
  productMigrationDetails?: ProductMigrationDetails
  productsSettings?: ProductsSettings | null
  switchFromExternalAdmin?: number
}

export default createContext<OrganizationContext | null>(null)
